(function (root) {
  'use strict';

  var TZ = 'Europe/Rome';

  /* Il giorno della settimana va letto nel fuso del negozio: un visitatore
     dall'estero altrimenti vedrebbe il giorno sbagliato a cavallo della
     mezzanotte. Intl e l'unico modo affidabile senza librerie. */
  function romeWeekday(date) {
    var name = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'short' }).format(date);
    var map = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    return map[name];
  }

  function isClosedDay(schedule, date) {
    var days = (schedule && schedule.closedDays) || [];
    return days.indexOf(romeWeekday(date)) !== -1;
  }

  var GIORNI = ['', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato', 'domenica'];

  function toMinutes(hhmm) {
    var p = String(hhmm || '').split(':');
    return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0);
  }

  /* Lettura severa di un orario: torna i minuti dalla mezzanotte oppure null
     se il valore non e' interpretabile. Serve perche' toMinutes('') vale 0,
     cioe' mezzanotte: un campo svuotato per sbaglio nel theme editor
     diventerebbe un orario vero e il sito affermerebbe qualcosa che nessuno
     ha impostato. Un campo vuoto non e' un orario, e' l'assenza di orario. */
  function parseTime(hhmm) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(String(hhmm == null ? '' : hhmm));
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (h > 23 || min > 59) return null;
    return h * 60 + min;
  }

  /* Il campo "giorni di chiusura" e' testo libero nel theme editor. Chi lo
     compila puo' scrivere "lunedi" invece di "1": con parseInt + filter(Boolean)
     quel refuso diventava un array vuoto, cioe' "nessuna chiusura", e il lunedi
     il sito scriveva "Aperte ora". Qui un valore non interpretabile si dichiara
     invalido e blocca ogni affermazione sugli orari, invece di sparire in
     silenzio. Stringa vuota resta valida e significa "nessuna chiusura
     settimanale": e' una configurazione legittima, non un errore.
     I duplicati si tolgono qui, cosi' "1,1" non diventa "Chiuso il lunedi e il
     lunedi" nella frase in fondo al pannello. */
  function parseClosedDays(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (s === '') return { days: [], valid: true };
    var parts = s.split(',');
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var t = parts[i].trim();
      if (!/^[1-7]$/.test(t)) return { days: [], valid: false };
      var n = parseInt(t, 10);
      if (out.indexOf(n) === -1) out.push(n);
    }
    return { days: out, valid: true };
  }

  /* I quattro orari in minuti, oppure null se l'orario nel suo insieme non e'
     interpretabile. closedDays === null e' il modo in cui chi legge le
     impostazioni segnala che i giorni di chiusura non si sono potuti leggere.
     La verifica sull'ordine intercetta il refuso che nessun controllo di
     formato vede: un 16:00 digitato per errore nella chiusura del mattino
     produrrebbe orari validi uno per uno e una giornata impossibile. */
  function scheduleTimes(schedule) {
    if (!schedule) return null;
    if (schedule.closedDays !== undefined && !Array.isArray(schedule.closedDays)) return null;
    var t = {
      mo: parseTime(schedule.morningOpen),
      mc: parseTime(schedule.morningClose),
      ao: parseTime(schedule.afternoonOpen),
      ac: parseTime(schedule.afternoonClose),
    };
    if (t.mo === null || t.mc === null || t.ao === null || t.ac === null) return null;
    if (!(t.mo < t.mc && t.mc <= t.ao && t.ao < t.ac)) return null;
    return t;
  }

  /* Minuti trascorsi dalla mezzanotte a Roma. Come per il giorno, l'orario
     va letto nel fuso del negozio e non in quello del visitatore. */
  function romeMinutes(date) {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(date);
    return toMinutes(f);
  }

  /* La data civile a Roma, per iterare sui giorni di calendario. */
  function romeParts(date) {
    var p = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(date).split('-');
    return { y: +p[0], m: +p[1], d: +p[2] };
  }

  /* Sommare 86400000 ms sposta di 24 ore REALI, non di un giorno civile.
     L'ultima domenica di marzo dura 23 ore: partendo dal sabato alle 23:30
     si atterrerebbe al lunedi, saltando del tutto la domenica di apertura.
     Si itera quindi sulla data civile, ancorata a mezzogiorno UTC, che a
     Roma e' sempre primo pomeriggio e non tocca mai un confine di giorno.
     Date.UTC gestisce da solo lo sbordo di mese e di anno. */
  function nextOpenDay(schedule, date) {
    var base = romeParts(date);
    for (var i = 1; i <= 7; i++) {
      var probe = new Date(Date.UTC(base.y, base.m - 1, base.d + i, 12, 0, 0));
      if (!isClosedDay(schedule, probe)) {
        return { offset: i, weekday: romeWeekday(probe) };
      }
    }
    return null;
  }

  /* Torna null quando l'orario non e' interpretabile, invece di rispondere
     comunque. E' il terzo stato che al flusso disponibilita' e' servito per
     non mentire: disponibile, non disponibile, non lo so. Senza, con un campo
     vuoto o un refuso nei giorni di chiusura questa funzione doveva per forza
     rispondere, e rispondeva con sicurezza. Chi chiama tratta null come
     "niente da scrivere". */
  function status(schedule, date) {
    var t = scheduleTimes(schedule);
    if (!t) return null;

    var now = romeMinutes(date);
    var mo = t.mo;
    var mc = t.mc;
    var ao = t.ao;
    var ac = t.ac;

    if (!isClosedDay(schedule, date)) {
      if (now >= mo && now < mc) return { open: true, closesAt: schedule.morningClose, reopensAt: null, reopensDay: null };
      if (now >= ao && now < ac) return { open: true, closesAt: schedule.afternoonClose, reopensAt: null, reopensDay: null };
      if (now < mo) return { open: false, closesAt: null, reopensAt: schedule.morningOpen, reopensDay: 'oggi' };
      if (now < ao) return { open: false, closesAt: null, reopensAt: schedule.afternoonOpen, reopensDay: 'oggi' };
    }

    var next = nextOpenDay(schedule, date);
    /* Tutti e sette i giorni marcati come chiusi: non c'e' una riapertura da
       annunciare. "Chiuse ora" senza seguito lascerebbe la frase a meta',
       quindi si tace del tutto. */
    if (!next) return null;
    return {
      open: false,
      closesAt: null,
      reopensAt: schedule.morningOpen,
      reopensDay: next.offset === 1 ? 'domani' : GIORNI[next.weekday],
    };
  }

  var api = {
    isClosedDay: isClosedDay,
    status: status,
    parseClosedDays: parseClosedDays,
    giorni: GIORNI,
    _romeWeekday: romeWeekday,
  };

  root.czBoutiqueHours = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = { czBoutiqueHours: api };
})(typeof window !== 'undefined' ? window : globalThis);
